export default __webpack_public_path__ + "static/media/five.7e18f420.svg";